<style>
  .trd-auth-shell{ min-height:78vh; display:flex; align-items:center; justify-content:center; padding:40px 16px; }
  .trd-auth-card{ width:400px; max-width:100%; padding:34px 32px 26px; border-radius:14px; text-align:left; }
  .trd-auth-logo{ width:54px; height:auto; display:block; margin-bottom:18px; border-radius:4px; }
  .trd-auth-title{ font:600 24px "Open Sans",sans-serif; margin:0 0 4px; color:rgba(0,0,0,.87); }
  .trd-auth-sub{ font:14px/1.5 "Open Sans",sans-serif; color:rgba(0,0,0,.6); margin:0 0 20px; }
  .trd-auth-form{ display:flex; flex-direction:column; }
  .trd-ff{ width:100%; }
  .trd-auth-btn{ width:100%; height:44px; font-weight:600; letter-spacing:.02em; }
</style>

<div class="trd-auth-shell">
  <mat-card class="trd-auth-card">
    <img class="trd-auth-logo" src="../../assets/new-home-page/images/logo.jpg" alt="TheRightDoctors"/>
    <h1 class="trd-auth-title">Set a new password</h1>
    <p class="trd-auth-sub">Choose a strong password you haven&rsquo;t used before.</p>
    <form role="form" (ngSubmit)="register()" #ff="ngForm" novalidate class="trd-auth-form">
      <mat-form-field appearance="outline" class="trd-ff">
        <mat-label>New password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" name="password" [(ngModel)]="model2.password" #password="ngModel" required>
        <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="'Toggle password visibility'">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" class="trd-ff">
        <mat-label>Confirm new password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" name="confirmpassword" [(ngModel)]="model2.confirmpassword" #confirmpassword="ngModel" required>
      </mat-form-field>
      <button mat-flat-button type="submit" class="trd-auth-btn">Update password</button>
    </form>
  </mat-card>
</div>
